import { Component, OnInit } from '@angular/core';
import { LocalService } from '../../../core';

@Component({
  selector: 'app-reward-transaction-tabs',
  templateUrl: './reward-transaction-tabs.component.html',
  styleUrls: ['./reward-transaction-tabs.component.scss'],
})
export class RewardTransactionTabsComponent implements OnInit {
  userProfile: any;
  isPointsTab: boolean = true;
  isTicketsTab: boolean = false;
  isCashTab: boolean = false;

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    if (this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM') {
      this.isTicketsTab = true;
      this.isPointsTab = false;
    }
  }

  getTabData(key: string) {
    this.isPointsTab = key === 'points';
    this.isTicketsTab = key === 'tickets';
    this.isCashTab = key === 'cash';
  }
}
